import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import api from '../utils/httpClient';
import type { UserConfigDb, InitialState } from '../slices/userConfig';

export const getLoggedInUserConfig = createAsyncThunk(
  'useConfig/getLoggedInUserConfig',
  async (userId: string) => {
    const { data } = await api.get(`/user/${userId}/config`);
    return {
      userId,
      ...data,
    } as UserConfigDb;
  }
);

const initialState: InitialState = {
  saving: false,
  error: '',
  success: false,
  configurations: {
    allowClassSession: {},
    allowSalesforceImport: {},
    allowReports: {},
    allowGroups: {},
    userConfig: {}
  },
};

const userLoggedInConfigSlice = createSlice({
  name: 'userLoggedInConfigSlice',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    // getLoggedInUserConfig
    builder.addCase(getLoggedInUserConfig.pending, (state) => {
      state.saving = true;
      state.success = false;
      state.error = '';
    });
    builder.addCase(
      getLoggedInUserConfig.fulfilled,
      (state, action: PayloadAction<UserConfigDb>) => {
        const { ...config } = action.payload;
        state.saving = false;
        state.success = true;
        state.error = '';
        state.configurations.allowSalesforceImport.allow = config.EnableSalesforceImport;
        state.configurations.allowReports.allow = config.CanAccessReports;
        state.configurations.allowGroups.allow = ((config.CanAccessGroups || config.IsAdmin) && config.AccountAccessGroups);
      }
    );
    builder.addCase(getLoggedInUserConfig.rejected, (state, action) => {
      console.error(action.error);
      state.saving = false;
      state.success = false;
      state.error = 'Unable to get configurations of the logged in user';
    });
  },
});

export const { reset } = userLoggedInConfigSlice.actions;
export default userLoggedInConfigSlice;
